export default __webpack_public_path__ + "static/media/typescriptlang-logo.78aa7804.svg";